export default function ChannelsSection() {
  const channels = [
    { icon: 'ri-telegram-line', name: 'Telegram', desc: 'Самый быстрорастущий канал. Неформальный стиль, скорость, боты, каналы. Учим вести диалог без шаблонов.' },
    { icon: 'ri-whatsapp-line', name: 'WhatsApp', desc: 'Основной канал для многих B2C и B2B. Голосовые, медиа, групповые чаты. Как выделяться среди спама.' },
    { icon: 'ri-computer-line', name: 'Bitrix24', desc: 'Встроенные чаты CRM. Как вести клиента внутри системы, фиксировать договорённости и не терять историю.' },
    { icon: 'ri-database-2-line', name: 'AmoCRM', desc: 'Чат-виджеты и коммуникация внутри воронки. Связка переписки с этапами сделки.' },
    { icon: 'ri-mail-send-line', name: 'Email', desc: 'Деловая переписка. Структура письма, тема, tone of voice. Как писать так, чтобы открывали и отвечали.' },
    { icon: 'ri-chat-smile-2-line', name: 'Jivo / LiveChat', desc: 'Онлайн-чаты сайта. Мгновенная реакция, квалификация лида и перевод в продажу за первые сообщения.' },
    { icon: 'ri-instagram-line', name: 'Instagram Direct', desc: 'Продажи через Direct. Визуальный контент + текст. Как вести клиента от сториз до сделки.' },
    { icon: 'ri-facebook-line', name: 'Facebook Messenger', desc: 'Чат-боты и живое общение. Автоматизация без потери человечности.' },
    { icon: 'ri-global-line', name: 'Онлайн-чаты сайта', desc: 'Виджеты на сайте. Быстрая реакция, квалификация и перевод в продажу.' },
  ];

  return (
    <section className="py-20 md:py-28 bg-gray-50">
      <div className="max-w-7xl mx-auto px-6">
        <div className="text-center mb-16">
          <div className="inline-flex items-center gap-2 bg-teal-50 text-teal-700 px-4 py-2 rounded-full text-sm font-semibold mb-6">
            <i className="ri-apps-line"></i>
            Каналы коммуникации
          </div>
          <h2 className="text-3xl md:text-5xl font-bold text-gray-900 mb-6">
            Какие каналы мы разбираем
          </h2>
          <p className="text-lg text-gray-600 max-w-3xl mx-auto leading-relaxed">
            Программа охватывает все современные каналы текстовой коммуникации. У каждого канала — своя специфика, и мы разбираем каждый.
          </p>
        </div>

        <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-5">
          {channels.map((item, i) => (
            <div key={i} className="bg-white rounded-xl p-5 md:p-6 border border-gray-100 hover:border-teal-100 transition-colors group flex items-start gap-4">
              <div className="w-12 h-12 bg-teal-600/10 rounded-xl flex items-center justify-center flex-shrink-0 group-hover:bg-teal-600/15 transition-colors">
                <i className={`${item.icon} text-teal-600 text-xl`}></i>
              </div>
              <div>
                <h3 className="text-base font-semibold text-gray-900 mb-1.5">{item.name}</h3>
                <p className="text-sm text-gray-600 leading-relaxed">{item.desc}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}